<template>
  <v-layout row wrap>
    <v-flex xs12 sm4>
      <v-card flat color="transparent">
        <v-card-text>
          <br />СБЕРБАНК<br />
          <ul class="c-details">
            <li>
              <a class="btn btn-link" href="http://banko-map.ru/%D0%A1%D0%B1%D0%B5%D1%80%D0%B1%D0%B0%D0%BD%D0%BA/%D0%9A%D0%B8%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F+%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C/%D0%9A%D0%B8%D1%80%D0%BE%D0%B2" target="blank">Терминалы</a>
            </li>
            <li>
              <a class="btn btn-link" href="/docs/Popolnenie_cherez_SberbankOnlayn.pdf" target="blank"><b>Сбербанк Онлайн</b></a>
            </li>
            <!-- <li>
              <a class="btn btn-link" href="/#/qr/sber"><span>Оплата по <b>QR-коду</b></span></a>
            </li> -->
          </ul>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm4>
      <v-card flat color="transparent">
        <v-card-text>
          <br />ХЛЫНОВ<br />
          <ul class="c-details">
            <li>
              <a class="btn btn-link" href="https://www.bank-hlynov.ru/atm/?address=" target="blank">Терминалы</a>
            </li>
            <li>
              <a class="btn btn-link" href="/docs/hlynov.pdf" target="blank"><b>Интернет Банк</b></a>
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm4>
      <v-card flat color="transparent">
        <v-card-text>
          <br />СИСТЕМА БЫСТРЫХ ПЛАТЕЖЕЙ<br />
          <ul class="c-details">
            <li>
              <a class="btn btn-link" href="/docs/instruction_sbp_schoolfood.pdf" target="blank"><b>Инструкция</b></a>
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'banks',
  computed: {
    profile () {
      return this.$store.state.profile
    }
  }
}
</script>

<style lang="css">
</style>
